module.exports = __webpack_public_path__ + "static/media/worldwide-coverage.f972aa9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/worldwide-coverage.jpg
// module id = 2162
// module chunks = 0